export default {
  // Admin - Customers List
  'admin.customers.title': '客户管理',
  'admin.customers.subtitle': '管理已注册的客户及其账户',
  'admin.customers.search': '搜索客户...',
  'admin.customers.filter.all': '全部',
  'admin.customers.filter.customer': '客户',
  'admin.customers.filter.admin': '管理员',
  'admin.customers.filter.superAdmin': '超级管理员',
  'admin.customers.columns.name': '姓名',
  'admin.customers.columns.email': '邮箱',
  'admin.customers.columns.company': '公司',
  'admin.customers.columns.country': '国家',
  'admin.customers.columns.role': '角色',
  'admin.customers.columns.joined': '加入时间',
  'admin.customers.columns.status': '状态',
  'admin.customers.columns.actions': '操作',
  'admin.customers.status.active': '正常',
  'admin.customers.status.inactive': '停用',
  'admin.customers.noResults': '未找到客户',
  'admin.customers.total': '{{count}} 位客户',
  'admin.customers.viewDetail': '查看详情',

  // Admin - Customer Detail
  'admin.customerDetail.back': '返回客户列表',
  'admin.customerDetail.title': '客户详情',
  'admin.customerDetail.profile': '个人资料',
  'admin.customerDetail.company': '公司信息',
  'admin.customerDetail.addresses': '地址',
  'admin.customerDetail.quotations': '报价单',
  'admin.customerDetail.orders': '订单',
  'admin.customerDetail.aiPreviews': 'AI 预览',
  'admin.customerDetail.noCompany': '未注册公司',
  'admin.customerDetail.noAddresses': '未注册地址',
  'admin.customerDetail.noQuotations': '未找到报价单',
  'admin.customerDetail.noOrders': '未找到订单',
  'admin.customerDetail.noPreviews': '未找到 AI 预览',
  'admin.customerDetail.roleChange': '更改角色',
  'admin.customerDetail.roleChangeHint': '仅超级管理员可以更改角色',
  'admin.customerDetail.save': '保存更改',
  'admin.customerDetail.basicInfo': '基本信息',
  'admin.customerDetail.contactInfo': '联系信息',
};